import { compose, withHandlers, branch, renderNothing, withProps } from 'recompose';
import { connect } from 'react-redux';

import {
  getActiveShopUserPermissionPasscode,
  activeShop,
  getIsShop,
  activeShopPermissionPassscodeEnabled,
  isShopUserPermissionPasscodeLoading,
  isBrandViewActive,
  getShopBrandId,
} from '../../../auth/selectors';
import {
  getBarberPermissionPasscode,
  isBarberPermissionCodeLoading,
  isBrandBarberPermissionPasscodeEnabled,
} from '../../../main/barbers/selector';
import {
  generateShopBarberPermissionPasscode,
  setShopBarberPermissionPasscode,
} from '../../../main/barbers/actions';
import {
  generateBrandBarberPermissionPasscode,
  setBrandBarberPermissionPasscode,
} from '../../../main/barbers/actions/brand';
import { generateShopUserPermissionPasscode, setShopUserPermissionPasscode } from '../../../auth/actions';

const mapStateToProps = (state, ownProps) => {
  const data = {
    shop: activeShop(state),
    currentPasscode: getActiveShopUserPermissionPasscode(state),
    isShopLoggedIn: getIsShop(state),
    isBrandLoggedIn: isBrandViewActive(state),
    permissionPasscodeEnabled: activeShopPermissionPassscodeEnabled(state),
    isPermissionCodeLoading: isShopUserPermissionPasscodeLoading(state),
  };

  if (ownProps.barberId) {
    data.barberId = ownProps.barberId;
    data.brandId = getShopBrandId(state);
    data.currentPasscode = getBarberPermissionPasscode(state, ownProps.barberId);
    data.isPermissionCodeLoading = isBarberPermissionCodeLoading(state);
    if (data.isBrandLoggedIn) {
      data.permissionPasscodeEnabled = isBrandBarberPermissionPasscodeEnabled(state);
    }
  }

  data.hasPasscode = Boolean(data.currentPasscode);

  return data;
};

const mapDispatchToProps = {
  generateShopUserPermissionPasscode,
  setShopUserPermissionPasscode,
  generateBrandBarberPermissionPasscode,
  generateShopBarberPermissionPasscode,
  setBrandBarberPermissionPasscode,
  setShopBarberPermissionPasscode,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    generateBarberPermissionPasscode:
      props.isBrandLoggedIn ? props.generateBrandBarberPermissionPasscode : props.generateShopBarberPermissionPasscode,
    setBarberPermissionPasscode:
      props.isBrandLoggedIn ? props.setBrandBarberPermissionPasscode : props.setShopBarberPermissionPasscode,
  })),
  withHandlers({
    generatePermissionPasscode: props => () => {
      if (props.barberId) {
        return props.generateBarberPermissionPasscode(props.brandId, props.barberId);
      }

      return props.generateShopUserPermissionPasscode(props.shop.id);
    },
    setPermissionPasscode: props => (code) => {
      if (props.barberId) {
        return props.setBarberPermissionPasscode(props.brandId, props.barberId, code);
      }

      return props.setShopUserPermissionPasscode(props.shop.id, code);
    },
  }),
  branch(
    props => !(props.isShopLoggedIn || props.isBrandLoggedIn) || !props.permissionPasscodeEnabled,
    renderNothing
  )
);
